export default "__VITE_ASSET__pq$X4aw9__"